namespace app.navigation {
    "use strict";
    import ITranslatePartialLoaderProvider = angular.translate.ITranslatePartialLoaderProvider;

    declare let SystemJS, System;
    
    /** @ngInject **/
    let config = ($translatePartialLoaderProvider, $ocLazyLoadProvider, $futureStateProvider, $provide, properties) => {
        
        $translatePartialLoaderProvider.addPart("app/main/navigation");
        
        /**
         * Define como os estados futuros do ui-router serão carregados
         */
        $futureStateProvider.stateFactory("load", /** @ngInject **/
             ($q, $ocLazyLoad, $log, $mdDialog, $translate, $futureState, $timeout, futureState, stylesLoadingService) => {
            
            let deferredState = $q.defer();
            
            let alert = $mdDialog.alert()
                .clickOutsideToClose(true)
                .title($translate.instant("NAVEGACAO.SERVICO_INDISPONIVEL.TITULO"))
                .textContent($translate.instant("NAVEGACAO.SERVICO_INDISPONIVEL.MSG"))
                .ariaLabel($translate.instant("NAVEGACAO.SERVICO_INDISPONIVEL.ALERTA"))
                .ok($translate.instant("NAVEGACAO.SERVICO_INDISPONIVEL.OK"));
            
            let fnErr = (err) => {
                $log.error(err);
                deferredState.reject();
                $mdDialog.show(alert);
                //Coloca o estado como futuro, para que tente acessar novamente
                $timeout(() => {
                    $futureState.futureState(futureState);
                });
            }
            
            //Realiza a importação dos arquivos dos módulos
            let context = futureState.src.split("/")[0];
            let bundle = context + "/bundle";
            
            var styleUrl = SystemJS.baseURL + context + "/style.css";
            $q.all([System.import(bundle), stylesLoadingService.loadStyle(styleUrl)]).then(() => {
                System.import(futureState.src).then((loaded) => {
                    var newModule = loaded;
                    
                    if (!loaded.name) {
                        var key = Object.keys(loaded);
                        newModule = loaded[key[0]];
                    }
                    //Carrega o módulo angular importado
                    $ocLazyLoad.load(newModule).then(() => {
                        deferredState.resolve();
                    }, fnErr);
                }, fnErr);
            });
            
            return deferredState.promise;
        });
        
        /**
         * Carrega as configurações das rotas dos módulos no FutureState do ui-router
         * possibilitando a garantia de que o estado estará carregado antes da transição
         * de estados ocorrer
         */
        $futureStateProvider.addResolve(/** @ngInject **/ ($q, $http, $rootScope, $window, $state, $timeout, $cookies) => {
            
            let deferredRoutes = $q.defer();
            
            let loadFutureRoutes = () => {	
                $http.get(properties.apiUrl + "/integracoes-modulos/api/routes").then((response) => {
                    response.data = response.data.filter(r => !!r.stateName);
                    
                    response.data.sort((r1, r2) => {
                        return r1.stateName.localeCompare(r2.stateName);
                    });
                    let temToken = $cookies.get("access_token") != null;
                    let publicState = null;
                    let publicStateParams = null;
                    let path = $window.location.pathname;
                    
                    response.data.forEach((route) => {
                        route.type = "load";
                        $futureStateProvider.futureState(route);
                        
                        if (route.stateName.indexOf("app.publico.") > -1) {
                            let params = route.urlMatcher.exec(path);

                            if (!!params) {
                                publicState = route.stateName;
                                publicStateParams = params;
                            }
                        }
                    });
                    if (!!publicState && !temToken) {
                        $timeout(() => $state.go(publicState, publicStateParams));
                    }
                    deferredRoutes.resolve();
                }, () => {
                    deferredRoutes.reject();
                });	
                
            };
            loadFutureRoutes();
            $rootScope.$on("user:logged", loadFutureRoutes);
            $rootScope.$on("user:exited", loadFutureRoutes);
            
            return deferredRoutes.promise;
            
        });
        
        //Configura o SystemJS para importar os arquivos através do gateway
        System.config({
            baseURL: properties.apiUrl,
            defaultExtension: "js",
            defaultJSExtensions: true,
            map: {
                "rxjs": `${document.baseURI}scripts/rxjs-system-bundle/index.js`,
                "rxjs-compat": `${document.baseURI}scripts/rxjs-system-bundle/index.js`,
                "rxjs/operators/": `${document.baseURI}scripts/rxjs-system-bundle/index.js`
            }
        });

        System.import("rxjs").catch(error => console.error("Erro ao carregas RxJS", error));

        //Adiciona um timestamp na url garantindo que no primeiro carregamento não vai ao cache
        let systemLocate = System.locate;
        System.locate = function (load) {
            var System = this;
            return Promise.resolve(systemLocate.call(this, load)).then(getUrlWithTimestamp);
        };
        
        if (properties.development) {
            $provide.decorator("$templateFactory", templateFactoryDecorator);
            $ocLazyLoadProvider.config({debug: false});
        }
    }
    
    //Desabilita o cache dos templates de módulos externos no ui-router.
    /** @ngInject **/
    let templateFactoryDecorator = ($delegate, properties) => {
        var fromUrl = angular.bind($delegate, $delegate.fromUrl);
        var gatewayUrl = properties.apiUrl; 
        $delegate.fromUrl = function (url, params) {
            
            if (url !== null && angular.isDefined(url) && angular.isString(url) && url.indexOf(gatewayUrl) !== -1) {
                url = getUrlWithTimestamp(url);
            }
            return fromUrl(url, params);
        };
        return $delegate;
    }
    
    //Monta uma url com um timestamp na querystring
    let getUrlWithTimestamp = (url) => {
        return url + (url.indexOf("?") === -1 ? "?" : "&") + "ts=" + Date.now().toString();
    }

    angular
        .module("app.navigation", 
            ["oc.lazyLoad", "ui.router", "ct.ui.router.extras", "app.support", "app.support.constants"])
        .config(config);
}
